<template>
	<ul class="main-tree" :dir="settings.treeDirection" v-if="showTable">
		<TreeItem v-for="(item, i) in treeData" :level="0" :isCompanyPeriodTree="settings.isCompanyPeriodTree" :checkboxOptions="settings.checkboxOptions" :fields="settings.customFields" :key="i" :modelValue="item" @update:modelValue="item" @change="val => emitChanges(val)" ref="treeItem" />
	</ul>
</template>

<script>
	import TreeItem from './TreeItem.vue'
	import _ from 'lodash'

	export default {
		name: 'Tree',
		components: {
			TreeItem,
		},
		props: {
			data: { type: Array, default: [] },
			options: { type: Object }
		},
		emits: ['change', 'update:data'],
		watch: {
			options: {
				deep: true,
				immediate: true,
				handler(val) {
					this.settings = _.merge(this.settings, val)
				}
			},
			data: {
				deep: true,
				immediate: false,
				handler() {
					this.refreshTree()
				}
			},
			treeData: {
				deep: true,
				immediate: true,
				handler(val) {
					this.emitTreeData(val)
				}
			},
		},
		created() {
			this.treeInit()
		},
		methods: {
			emitTreeData(data) {
				this.$emit('update:data', data)
			},

			getField(level) {

				const isCustomFieldArray = _.isArray(this.settings.customFields)

				let fields

				if (isCustomFieldArray)
					fields = this.settings.customFields[level] ? this.settings.customFields[level] : this.settings.customFields[0]
				else
					fields = this.settings.customFields

				return fields
			},

			refreshTree() {
				setTimeout(() => {

					this.showTable = false
					let clonedData = _.cloneDeep(this.data)

					this.treeData = clonedData
					this.showTable = true
				}, 1)

			},
			changeAllItemsState(state) {

				const stateChanger = (items, state, level = 0) => {

					let fields = this.getField(level)

					for (let item of items) {
						item[fields.state].isChecked = state

						if (item[fields.children])
							stateChanger(item[fields.children], state, level + 1)
					}

				}

				let clonedData = _.cloneDeep(this.treeData)
				stateChanger(clonedData, state)
				this.treeData = clonedData


			},

			changeItemStateByKeyValue(key, value, state) {

				var found = false
				var foundedItem = null
				var foundedItemLevel = null

				const recursiveItemFinder = (treeItems, level = 0) => {

					let fields = this.getField(level)


					for (let item of treeItems) {
						if (item[key] == value) {
							foundedItem = item
							foundedItemLevel = level
							found = true
							break
						}

						if (item[fields.children]?.length) {
							recursiveItemFinder(item[fields.children], level + 1)
							if (found) {
								break
							}
						}
					}

				}

				recursiveItemFinder(this.treeData)

				if (found && foundedItem) {
					const stateChanger = (item, state, level) => {

						let fields = this.getField(level)

						item[fields.state].isChecked = state

						if (item[fields.children]) {
							for (let child of item[fields.children]) {
								stateChanger(child, state, level + 1)
							}
						}

					}

					stateChanger(foundedItem, state, foundedItemLevel)
				}

			},

			emitChanges(val) {
				this.$emit('change', val)
			},
			treeInit() {
				let cloneData = _.cloneDeep(this.data)

				cloneData = this.addOrCheckStateFieldtoData(cloneData, false)

				this.treeData = cloneData
			},
			addOrCheckStateFieldtoData(dataList, parentState = false, level = 0) {

				let fields = this.getField(level)

				for (let i = 0; i < dataList.length; i++) {
					if (parentState == true) {
						dataList[i][fields.state] = { isChecked: true }
					}
					else if (!dataList[i][fields.state] || _.isEmpty(dataList[i][fields.state])) {
						if (dataList[i][fields.children]) {
							const children = this.getLastLevelItems(dataList[i][fields.children]).every(child => child[this.settings.customFields.state] && child[this.settings.customFields.state].isChecked === true)
							dataList[i][fields.state] = { isChecked: children }
						}
						else {
							dataList[i][fields.state] = { isChecked: false }
						}
					}
					else {
						if (dataList[i][fields.children]) {
							const children = this.getLastLevelItems(dataList[i][fields.children]).every(child => child[this.settings.customFields.state] && child[this.settings.customFields.state].isChecked === true)
							dataList[i][fields.state] = { isChecked: children }
						}
					}

					let nextLevel = level + 1
					if (dataList[i][fields.children]?.length > 0)
						dataList[i][fields.children] = this.addOrCheckStateFieldtoData(dataList[i][fields.children], dataList[i][fields.state].isChecked, nextLevel)

				}
				return dataList
			},
			getLastLevelItems(items) {
				let lastLevelItems = []

				const getComputeds = (item) => {
					if (item[this.settings.customFields.children]?.length) {
						item[this.settings.customFields.children].forEach(child => getComputeds(child))
					} else {
						lastLevelItems.push(item)
					}
				}

				for (let i = 0; i < items.length; i++) {
					getComputeds(items[i])
				}

				return lastLevelItems
			},
			getLastLevelChecked() {
				let result = _.cloneDeep(this.treeData)

				let computed = []

				const getComputeds = (item) => {
					if (item[this.settings.customFields.children]?.length) {
						item[this.settings.customFields.children].forEach(child => getComputeds(child))
					} else {
						if (item[this.settings.customFields.state].isChecked) {
							computed.push(item)
						}
					}
				}

				for (let i = 0; i < result.length; i++) {
					getComputeds(result[i])
				}

				return computed
			},
		},
		data() {
			return {
				treeData: [],
				showTable: true,
				settings: {
					treeDirection: 'rtl', // ltr | rtl
					customFields: {
						text: 'text',
						children: 'children',
						state: 'state'
					},
					// customFields: [
					// 	{
					// 		text: 'text',
					// 		children: 'children',
					// 		state: 'state'
					// 	},
					// 	{
					// 		text: 'esm',
					// 		children: 'items',
					// 		state: 'state'
					// 	},
					// 	{
					// 		text: 'matn',
					// 		children: 'bache',
					// 		state: 'state'
					// 	},
					// ],
					checkboxOptions: {
						checkedColor: '#466eb5',
						unCheckedColor: 'white'
					}
				}
			}
		},
	}
</script>

<style scoped>
	ul {
		list-style-type: none;
	}

	li {
		list-style: none;
		margin: 0px 10px;
	}

	a {
		color: #42b983;
	}
</style>
